import type { ApplicationGateApi } from '@tempmee/awards';
import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { AWARDS_API_PREFIX } from './awardsApiBase';

/**
 * Fetch the application gate + form for a cycle —
 * `GET /cycles/{cycleId}/applications` (awards-service#41), the GET sibling
 * of the submit POST. One call answers "may this caller apply" and "what
 * form do I render"; `questions` is served ONLY when eligible.
 *
 * The gate is deliberately STRICTER than `GET /cycles`' `applyEligible`
 * (it also checks for a retained application row and the identity mirror),
 * so `eligible: false` right after an Apply click is a designed, reachable
 * state the form must render — not an error. `unknown-identity` is
 * transient mirror lag and worth a retry.
 */
export const getApplicationQuestions = async (cycleId: string): Promise<ApplicationGateApi> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<ApplicationGateApi>(
    `${AWARDS_API_PREFIX}/cycles/${cycleId}/applications`,
    { headers },
  );
  return response.data;
};
